// extracted by mini-css-extract-plugin
export default {"container":"t5w7","ruleOption":"taHY","btn":"Sn13"};